import type { CrmContact } from "../api/crm";

const primaryOf = (contact: CrmContact, type: string, fallback?: string) => {
  const methods = (contact.contact_methods ?? []).filter(
    (method) => method.type === type
  );
  const primary = methods.find((method) => method.is_primary) ?? methods[0];
  return primary?.value ?? fallback;
};

export const primaryEmail = (contact: CrmContact) =>
  primaryOf(contact, "email", contact.emails[0]);

export const digitsOnly = (value: string) => {
  const digits = value.replace(/\D/g, "");
  return digits.length === 11 && digits.startsWith("1")
    ? digits.slice(1)
    : digits;
};

const last10 = (value: string) => value.replace(/\D/g, "").slice(-10);

export const primaryPhone = (contact: CrmContact) => {
  const raw = primaryOf(contact, "phone");
  if (!raw) return contact.phones[0];
  return contact.phones.find((phone) => last10(phone) === last10(raw)) ?? raw;
};
